var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"c-panel\"><div ng-form=\"vm.form\" novalidate=\"\" class=\"form layout\"><admin-users-form resource=\"vm.user\" account-settings=\"true\"></admin-users-form></div><div class=\"c-panel__footer\"><div class=\"text-right\"><a id=\"user-save-btn\" ng-if=\"vm.showResetMfa()\" ng-click=\"vm.resetMfa()\" class=\"o-btn c-btn c-btn--outlined\">{{ 'reset_mfa' | translate }}</a><a id=\"user-save-btn\" ng-click=\"!(vm.form.$invalid || vm.isResourceBeingPersisted || vm.isDemoAccount()) &amp;&amp; vm.save()\" ng-class=\"{'is-disabled': vm.form.$invalid || vm.isResourceBeingPersisted || vm.isDemoAccount()}\" class=\"o-btn c-btn c-btn--outlined\">{{ 'update' | translateWith:'user' }}</a></div></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/account/settings/settingsUserEdit.jade
 ** module id = 612
 ** module chunks = 0
 **/